var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _c("div", { staticClass: "checkbox" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.isStayRestricted,
              expression: "isStayRestricted",
            },
          ],
          attrs: { type: "checkbox", disabled: _vm.field.disabled },
          domProps: {
            checked: Array.isArray(_vm.isStayRestricted)
              ? _vm._i(_vm.isStayRestricted, null) > -1
              : _vm.isStayRestricted,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.isStayRestricted,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.isStayRestricted = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.isStayRestricted = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.isStayRestricted = $$c
              }
            },
          },
        }),
      ]),
      _vm._v(" "),
      _vm.isStayRestricted
        ? _c("ies-date-range-rows", {
            attrs: {
              "date-ranges": _vm.dateRanges,
              disabled: _vm.field.disabled,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }